import React from 'react';
import { Navbar } from '../components/Navbar';
import { ClompApi } from '../api/ClompApi';
import './NewsPage.css';

const api = new ClompApi();

const dateFormat = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
};

// Turn any http(s) URLs in a post body into links
function linkify(text) {
    return text.split(/(https?:\/\/[^\s]+)/g).map((part, i) =>
        i % 2 === 1 ?
            <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a>
            :
            part
    );
}

export class NewsPage extends React.Component {

    state = {
        posts: [],
        loading: true,
        error: false
    };

    componentDidMount() {
        api.news.getNews().then((posts) => {
            this.setState({ posts: posts, loading: false });
        }).catch((err) => {
            console.log('Error loading news: ', err);
            this.setState({ loading: false, error: true });
        });
    }

    renderPosts() {
        if (this.state.loading) {
            return <p className="news-status">Loading news...</p>;
        }
        if (this.state.error) {
            return <p className="news-status">Couldn't load the news right now. Please try again later.</p>;
        }
        if (this.state.posts.length === 0) {
            return <p className="news-status">No news yet. Check back soon!</p>;
        }

        return (
            <ul className="news-list">
                {this.state.posts.map((post) => (
                    <li className="news-post" key={post.id}>
                        <h2>{post.title}</h2>
                        <time className="news-post-date" dateTime={post.postedAt}>
                            {new Date(post.postedAt).toLocaleString(undefined, dateFormat)}
                        </time>
                        <p className="news-post-body">{linkify(post.body)}</p>
                    </li>
                ))}
            </ul>
        );
    }

    render() {

        return (
            <>
                <Navbar history={this.props.history}></Navbar>
                <div className="news-page">
                    <div className="news-page-header">
                        <h1>News</h1>
                    </div>
                    {this.renderPosts()}
                </div>
            </>
        );

    }

}
